let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4M8Og")).then(() => parcelRequire('aPFD1'));